<template>
  <div>
    <v-container>
      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="609"
            @click:outside="closeModal"
            :retain-focus="false"
          >
            <v-card class="custom-card" rounded="0">
              <v-toolbar color="secondary" class="white--text">
                <v-toolbar-title class="font-weight-bold">
                  {{ $t("ration.rationSuggestion") }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-form ref="addUser" lazy-validation autocomplete="off">
                <div
                  class="pt-5 text-center"
                  style="width: 100%; overflow: hidden"
                >
                  <p class="px-10 py-4">
                    {{ $t("ration.suggestionText") }}
                  </p>

                  <v-btn-toggle color="green">
                    <v-btn @click="setPriority('lowest_price')">
                      {{ $t("ration.lowestPrice") }}
                    </v-btn>
                    <v-btn @click="setPriority('expire_soon')">
                      {{ $t("ration.expireSoon") }}
                    </v-btn>
                  </v-btn-toggle>
                </div>

                <v-card-text class="black--text">
                  <v-card-actions class="mt-10" style="padding-right: 0">
                    <v-btn
                      class="mr-2"
                      right
                      height="44"
                      width="116"
                      depressed
                      color="primary"
                      outlined
                      @click="closeModal()"
                    >
                      Back
                    </v-btn>
                    <v-spacer></v-spacer>

                    <v-btn right height="44" color="primary" @click="proceed">
                      Proceed
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
export default {
  data() {
    return {
      rationPriority: null,
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [loadingMixin],
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },

    setPriority(type) {
      this.rationPriority = type;
    },

    async proceed() {
      this.$emit("rationPriority", this.rationPriority);
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field--enclosed .v-input__append-inner {
  margin-top: 10px;
}

::v-deep .v-input__control fieldset {
  border: none;
}
::v-deep .v-input__slot fieldset:first-child {
  border-top: 1px solid #bbb;
}
::v-deep .v-form span:last-child .v-input__slot fieldset {
  border-bottom: 1px solid #bbb;
}
::v-deep .highlightedInput {
  border: 1px solid #00bd73;
  border-width: 1px 0 1px 0;
  border-radius: 0;
}
.v-btn-toggle {
  color: #00c26b;
}
::v-deep.v-btn-toggle > .v-btn.v-btn--active {
  color: white !important;
  background: #00c26b;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 50px;
  width: 10em;
  color: #00c26b;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #00c26b !important;
}

.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #00c26b !important;
  color: #00c26b !important; /* Set the default text color to green */
}

.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn:hover {
  border-color: #00c26b !important;
  background-color: #00c26b !important; /* Set the hover background color to green */
  color: #ffffff !important; /* Set the hover text color to white */
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn--active {
  border-color: #00c26b !important;
  color: white !important;
}
</style>
